import React, { FC, ReactNode } from 'react';

import { Box, BoxProps, Center } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

import { CustomTooltip, CustomTooltipStyles } from 'components/DataDisplay';

interface IPlusCountTag extends BoxProps {
  count: number;
  color?: string;
  px?: string | number;
  py?: string | number;
  tooltip?: ReactNode;
  tooltipStyles?: CustomTooltipStyles;
}

export const PlusCountTag: FC<IPlusCountTag> = props => {
  const {
    count,
    color,
    px = 1,
    py = '1px',
    tooltip,
    tooltipStyles,
    onClick,
    ...rest
  } = props;

  const renderTag = () => (
    <Box
      color={color ?? customTheme.colors.primary}
      cursor={onClick ? 'pointer' : 'default'}
      bg={colorOpacity(color ?? customTheme.colors.primary, 0.15)}
      px={px}
      py={py}
      borderRadius={6}
      onClick={onClick}
      {...rest}
    >
      <Center>{'+' + count}</Center>
    </Box>
  );

  return tooltip ? (
    <CustomTooltip label={tooltip} styles={tooltipStyles}>
      {renderTag()}
    </CustomTooltip>
  ) : (
    renderTag()
  );
};
